import React from "react";
import ListMenu from "./list_categori";
import ListDropdown from "./ListDropdown";
import bannerImage from "../../assets/bannnersolaria.png";
import Scroll from "./ScrollTop"
import KategoriDrink from "./KategoriDrink"
// idrink utama layout utama

export default function Menu() {
  return (
    <div>
      {/* <BannerMenu/> */}
      <KategoriDrink />
      {/* <div className="pt-8  text-center">
        <h2 className="text-4xl font-semibold text-black">
          Menu <span className="text-pink-500">Kami</span>
        </h2>
      </div> */}
      <ListMenu />
      <Scroll />
    </div>

  );
}
